import VueRouter from "vue-router";
//import VueMouseflow from "vue-mouseflow";
import { store } from "../store";
import KrAuth from "../components/auth/auth";
let routes = [
  {
    path: "/",
    name: "/",
    component: require("../views/layouts/main/layout.vue").default,
    children: [
      {
        path: "/",
        name: "auth.demo",
        component: require("../views/auth/demo.vue").default,
      },
      {
        path: "/demo",
        name: "auth.demo",
        component: require("../views/auth/demo.vue").default,
      },
      {
        path: "/in",
        component: require("../views/layouts/main/internal-layout.vue").default,
        children: [
          {
            path: "profile",
            name: "profile.view",
            meta: {
              auth: true,
              title: "My Profile | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/profile/index.vue").default,
          },
          {
            path: "profile/edit",
            name: "profile.edit",
            meta: {
              auth: true,
              title: "Edit My Profile | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/profile/edit.vue").default,
          },
          {
            path: "tests",
            name: "tests.index",
            meta: { auth: true },
            component: require("../views/main/tests/index.vue").default,
          },
          {
            path: "tests/:id",
            name: "tests.proper",
            meta: {
              auth: true,
              title: "Test | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/test.vue").default,
          },
          {
            path: "tests/:id/discussion",
            name: "tests.discussion",
            meta: {
              auth: true,
              title: "Discussion | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/e-gallery-walk/index.vue")
              .default,
          },
          {
            path: "tests/:id/clarification",
            name: "tests.clarification",
            meta: {
              auth: true,
              title: "Clarification | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/trat/clarification.vue")
              .default,
          },
          {
            path: "tests/:id/prework",
            name: "tests.prework",
            meta: {
              auth: true,
              title: "Prework | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/prework/index.vue")
              .default,
          },
          {
            path: "tests/:id/instruction",
            name: "tests.instruction",
            meta: {
              auth: true,
              title: "Instruction | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/instruction.vue").default,
          },
          {
            path: "tests/:id/trat-report",
            name: "tests.trat-report",
            meta: {
              auth: true,
              title: "TRAT Report | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/trat/report.vue")
              .default,
          },
          {
            path: "tests/:id/irat-report",
            name: "tests.irat-report",
            meta: {
              auth: true,
              title: "IRAT Report | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/irat/report.vue")
              .default,
          },
          {
            path: "tests/:id/evaluation-report",
            name: "tests.evaluation-report",
            meta: {
              auth: true,
              title: "Evaluation Report | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/evaluation/report.vue")
              .default,
          },
          {
            path: "tests/:id/application-report",
            name: "tests.application-report",
            meta: {
              auth: true,
              title:
                "Application Report | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/application/report.vue")
              .default,
          },
          //for irat trat application
          {
            path: "tests/:id/preview-rat",
            name: "tests.preview.rat",
            meta: {
              auth: true,
              title: "Preview Test | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/test.vue").default,
          },
          {
            path: "tests/:id/preview-prework",
            name: "teachers.tests.preview.prework",
            meta: {
              auth: true,
              title: "Preview Prework | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/prework/index.vue")
              .default,
          },
          {
            path: "teachers/tests/:id/preview-rat",
            name: "teachers.tests.preview.rat",
            meta: {
              auth: true,
              title: "Preview Test | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/test.vue").default,
          },
          {
            path: "tests/:id/preview-evaluation",
            name: "tests.preview.evaluation",
            meta: {
              auth: true,
              title:
                "Preview Evaluation | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/rat/test.vue").default,
          },
          {
            path: "teachers/tests/:id/preview-evaluation",
            name: "teachers.tests.preview.evaluation",
            meta: {
              auth: true,
              title:
                "Preview Evaluation | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/evaluation/evaluation.vue")
              .default,
          },
          {
            path: "tests/:id/evaluation",
            name: "tests.evaluation",
            meta: {
              auth: true,
              title: "Evaluation | InteDashboard | TBL Makes Teams Work",
            },
            component: require("../views/main/tests/evaluation/evaluation.vue")
              .default,
          },
        ],
      },
    ],
  },
  {
    path: "/404",
    name: "errors.404",
    component: require("../views/errors/404.vue").default,
  },
  {
    path: "/403",
    name: "errors.403",
    component: require("../views/errors/403.vue").default,
  },
  {
    path: "/500",
    name: "errors.500",
    component: require("../views/errors/500.vue").default,
  },
  { path: "*", redirect: "/404" },
];
let r = new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  linkExactActiveClass: "",
  routes: routes,
});
r.beforeEach((to, from, next) => {
  $(".modal").modal("hide");
  window.scrollTo(0, 0);
  var auth = new KrAuth();
  document.title = to.meta.title || "InteDashboard | TBL Makes Teams Work";
  if (!to.matched.some((record) => record.meta.auth)) {
    //unsecured
    
    if (auth.isLoggedIn()) {
      if (
        to.name == "auth.password.reset" ||
        (to.query.access_token && to.query.api_url)
      ) {
        auth.logout();
      }
      if (
        to.name != "errors.403" &&
        to.name != "errors.404" &&
        to.name != "errors.500"
      ) {
        if (auth.user().role == "demo") {
          next({ name: "tests.index" });
        }
      }
    }
    next();
  } else if (to.matched.some((record) => record.meta.auth)) {
    //secured
    if (!auth.isLoggedIn()) {
      /*next({
		      	name: 'auth.login',
	    	})*/
    } else {
      if (
        to.matched.some(
          (record) =>
            record.meta.role && !record.meta.role.includes(auth.user().role)
        )
      ) {
        next({
          name: "errors.403",
        });
      }
    }
  }
  next();
});
r.afterEach((to) => {
  //VueMouseflow.logRouteChange(to, { includeRouteParams: true });
});
export const router = r;
